/* global am4charts, bocAmchart4 */
/**
 * @param {am4charts.XYChart} chart object
 * @param {array} data for the chart
 * @param {bool} vertical orientation
 * @returns {void}
 * Creates a category axis and adds labels according to '-' split
 */
bocAmchart4.generateMultiLevelAxis = function (chart, data, vertical) {
    var categoryAxis, extraCategoryAxis;
    if (vertical) {
        categoryAxis = chart.yAxes.getIndex(0);
        extraCategoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
        extraCategoryAxis.renderer.inversed = true;
        chart.leftAxesContainer.reverseOrder = true;
    } else {
        categoryAxis = chart.xAxes.getIndex(0);
        extraCategoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        chart.bottomAxesContainer.reverseOrder = true;
    }

    extraCategoryAxis.dataFields.category = "category";
    extraCategoryAxis.renderer.grid.template.disabled = true;
    extraCategoryAxis.renderer.grid.template.location = 0;
    extraCategoryAxis.cursorTooltipEnabled = false;
    extraCategoryAxis.renderer.labels.template.wrap = true;
    extraCategoryAxis.renderer.labels.template.fontSize = 0;

    var category, prevCategory = "";
    var index = 0;
    var start = 0;
    var end;
    var rangeLabel = "";
    var separator = "|";
    if (chart.bocSettings.args.hasOwnProperty('multilevelseparator')) {
        separator = chart.bocSettings.args.multilevelseparator;
    }

    data.forEach(function (dataPoint) {
        category = dataPoint.category.split(separator)[0];

        if (category !== prevCategory && index !== 0) {
            // Found the end of the current upper level category
            end = index - 1;
            rangeLabel = data[end].category.split(separator)[0];
            createRange(chart, data[start].category, data[end].category, rangeLabel);
            start = index;
        }

        if (index === (data.length - 1)) {
            // Reached the end, wrap it up
            end = data.length - 1;
            rangeLabel = data[end].category.split(separator)[0];
            createRange(chart, data[start].category, data[end].category, rangeLabel);
        }
        prevCategory = category;
        index++;
    });

    /**
     * Creates ranges and populates with gridlines and ticks
     * @param {chart} chart   object
     * @param {string} from Starting point of range
     * @param {string} to Ending point of range
     * @param {string} label Text to assign range
     * @returns {void}

     */
    function createRange(chart, from, to, label) {
        var range = extraCategoryAxis.axisRanges.create();
        range.label.fontSize = "0.9em";
        range.category = from;
        range.endCategory = to;
        range.label.text = label;
        range.label.wrap = true;
        range.label.truncate = false;
        range.label.location = 0.5;
        range.label.paddingTop = vertical ? 12 : 0;
        range.label.horizontalCenter = "middle";
        range.label.textAlign = vertical ? "end" : "middle";
        range.label.fontWeight = "bolder";
        range.grid.strokeOpacity = 1;
        range.tick.disable = false;
        range.tick.location = 0;
        range.tick.strokeWidth = 1;
        range.tick.strokeOpacity = 1;
        if (vertical) {
            chart.events.on("validated", function (event) {
                let labelWidth = 200;
                if (chart.bocSettings.args.hasOwnProperty('multilevellabelwidth')) {
                    labelWidth = parseInt(chart.bocSettings.args.multilevellabelwidth);
                }

                if (event.target.contentWidth > labelWidth * 3) {
                    range.label.maxWidth = labelWidth;
                } else {
                    range.label.maxWidth = event.target.contentWidth * 0.333;
                }
                range.tick.length = -categoryAxis._absoluteWidth;
            });
        } else {
            range.axisFill.isMeasured = true;
            range.label.adapter.add("maxWidth", function (maxWidth, target) {
                let labelWidth, maxLabelWidth, availableSpace;
                availableSpace = target.dataItem.axisFill.measuredWidth;
                labelWidth = availableSpace;
                if (chart.bocSettings.args.hasOwnProperty('multilevellabelwidth')) {
                    maxLabelWidth = parseInt(chart.bocSettings.args.multilevellabelwidth);
                    if (maxLabelWidth < availableSpace) {
                        labelWidth = maxLabelWidth;
                    }
                }
                range.tick.length = -categoryAxis._absoluteHeight;
                return labelWidth;
            });
        }
    }
};
